import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=c682f5f8&scoped=true"
import script from "./TextEditor.vue?vue&type=script&lang=js"
export * from "./TextEditor.vue?vue&type=script&lang=js"
import style0 from "./TextEditor.vue?vue&type=style&index=0&id=c682f5f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c682f5f8",
  null
  
)

export default component.exports